import { SearchObject } from "app/common/Model/SearchObject";
import { PageResponse } from "app/common/Model/Shared";
import {
  pagingComplaintTicket,
  searchCustomerTickets,
} from "app/services/ComplaintService";
import { pagingCustomerTicket } from "app/services/CustomerTicketService";
import { getPatientOverviewById } from "app/services/PatientService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";

export default class ComplaintStore {
  searchComplaint = {
    ...new SearchObject(),
    isComplaint: true,
    clientCode: null,
  };
  pageRegisterComplaint = new PageResponse();
  dataVoucherFee = null;
  constructor() {
    makeAutoObservable(this);
  }

  getDataComplaint = async () => {
    try {
      const { data } = await pagingComplaintTicket(this.searchComplaint);
      this.pageRegisterComplaint = {
        ...data,
        content: data.content,
      };
      this.dataVoucherFee = data;
    } catch (error) {
      console.error(error);
      toast.error("Lấy dữ liệu khiếu nại có lỗi");
    }
  };

  handleChangeFormSearchComplaint = (searchComplaint) => {
    this.searchComplaint = {
      ...this.searchComplaint,
      ...searchComplaint,
    };
    // console.log("🔍 searchComplaint gọi API:", this.searchComplaint);
    this.getDataComplaint();
  };
}
